import { render } from "./add-rich-menu.vue?vue&type=template&id=2610bd34&scoped=true"
import script from "./add-rich-menu.vue?vue&type=script&lang=js"
export * from "./add-rich-menu.vue?vue&type=script&lang=js"

import "./add-rich-menu.vue?vue&type=style&index=0&id=2610bd34&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2610bd34"]])

export default __exports__